'use client'

import { cn } from '@/lib/utils'
import { HTMLAttributes } from 'react'

interface LoadingProps extends HTMLAttributes<HTMLDivElement> {}

export const Loading = ({ ...props }: LoadingProps) => {
  return (
    <div
      className={cn(
        'absolute top-0 left-0 w-full h-full flex items-center justify-center space-x-2 bg-white/50 backdrop-blur-sm z-30',
        props.className,
      )}
      {...props}
    >
      <div className='h-4 w-4 bg-zinc-800 rounded-full animate-bounce [animation-delay:-0.3s]' />
      <div className='h-4 w-4 bg-zinc-800 rounded-full animate-bounce [animation-delay:-0.15s]' />
      <div className='h-4 w-4 bg-zinc-800 rounded-full animate-bounce' />
    </div>
  )
}
